import { useDispatch, useSelector } from 'react-redux'; // Add this if it's not already imported
import { Stack, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTheme } from '@mui/material/styles';
import { handleLogout } from '../../../../store/reducers/accountSlice';
import { activeItem } from '../../../../store/reducers/menu';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

// project import
import MainCard from 'components/MainCard';

// ==============================|| DRAWER CONTENT - NAVIGATION CARD ||============================== //

const NavCard = () => {
  // Use useSelector hook to access the current state of the drawer
  const { drawerOpen, openItem } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.account);

  const logoutHandler = () => {
    dispatch(handleLogout(token));
  };

  const theme = useTheme();
  //   const textColor = 'text.primary';
  const iconSelectedColor = 'primary.main';

  const listItemButtonStyle = (drawerOpen, theme, iconSelectedColor) => ({
    zIndex: 1201,
    pl: drawerOpen ? 3 : 0,
    // Commented out as it seems you've removed the py settings
    // py: !drawerOpen ? 1.25 : 1,
    ...(drawerOpen && {
      '&:hover': {
        bgcolor: 'primary.lighter'
      },
      '&.Mui-selected': {
        bgcolor: 'primary.lighter',
        borderRight: `2px solid ${theme.palette.primary.main}`,
        color: iconSelectedColor,
        '&:hover': {
          color: iconSelectedColor,
          bgcolor: 'primary.lighter'
        }
      }
    }),
    ...(!drawerOpen && {
      '&:hover': {
        bgcolor: 'transparent'
      },
      '&.Mui-selected': {
        '&:hover': {
          bgcolor: 'transparent'
        },
        bgcolor: 'transparent'
      }
    })
  });

  const commonListItemButtonSx = listItemButtonStyle(drawerOpen, theme, iconSelectedColor);

  const navigateToProfile = () => {
    navigate('/profile');
    dispatch(activeItem({ openItem: ['profile'] })); // Update active item in the store
  };

  const isProfileSelected = openItem.includes('profile');

  return (
    <MainCard
      sx={{ bgcolor: 'grey.50', m: drawerOpen ? 3 : 0.5 }}
      contentSX={{
        padding: drawerOpen ? '16px' : '14px' // Change these values as needed
        // Add other styles you want to apply dynamically
      }}
    >
      <Stack direction="column" spacing={1}>
        {/* Profile Item */}
        <ListItemButton sx={commonListItemButtonSx} onClick={navigateToProfile} selected={isProfileSelected}>
          <Stack direction="row" spacing={2} alignItems="center">
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            {drawerOpen && <ListItemText primary="Profile" />}
          </Stack>
        </ListItemButton>

        {/* Logout Item */}
        <ListItemButton sx={commonListItemButtonSx} onClick={logoutHandler}>
          <Stack direction="row" spacing={2} alignItems="center">
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            {drawerOpen && <ListItemText primary="Logout" />}
          </Stack>
        </ListItemButton>
      </Stack>
    </MainCard>
  );
};

export default NavCard;
